export default "__VITE_ASSET__DBMEgiX$__"